import React from 'react';

const IconDiscountItem = () => {
  return (
    <svg
      width='30'
      height='30'
      viewBox='0 0 30 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.7554 0.194208C15.2856 -0.0647359 14.7144 -0.0647359 14.2446 0.194208L2.81224 6.4953L15.0246 13.8701L27.7454 6.80268L15.7554 0.194208ZM29 8.75884L16.1667 15.8887V30L28.1998 23.3677C28.6937 23.0956 29 22.5791 29 22.0187V8.75884ZM13.8333 30V15.8608L1 8.11094V22.0187C1 22.5791 1.30627 23.0956 1.80012 23.3677L13.8333 30Z'
        fill='#2F3D48'
      />
    </svg>
  );
};

export default IconDiscountItem;
